export default {
  SET_CATEGORY: "SET_CATEGORY",
  SET_INPUT_VALUE: "SET_INPUT_VALUE",
  SET_CREDIT: "SET_CREDIT",
  SET_SOLICITATION: "SET_SOLICITATION"
}
